var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.5C16.9706 21.5 21 17.4706 21 12.5C21 7.52944 16.9706 3.5 12 3.5C7.02944 3.5 3 7.52944 3 12.5C3 17.4706 7.02944 21.5 12 21.5Z",
    stroke: "url(#paint0_linear_1136_22706)",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7071 11.2071C16.0976 10.8166 16.0976 10.1834 15.7071 9.79289C15.3166 9.40237 14.6834 9.40237 14.2929 9.79289L15.7071 11.2071ZM11 14.5L10.2929 15.2071C10.6834 15.5976 11.3166 15.5976 11.7071 15.2071L11 14.5ZM9.70711 11.7929C9.31658 11.4024 8.68342 11.4024 8.29289 11.7929C7.90237 12.1834 7.90237 12.8166 8.29289 13.2071L9.70711 11.7929ZM14.2929 9.79289L10.2929 13.7929L11.7071 15.2071L15.7071 11.2071L14.2929 9.79289ZM11.7071 13.7929L9.70711 11.7929L8.29289 13.2071L10.2929 15.2071L11.7071 13.7929Z",
    fill: "url(#paint1_linear_1136_22706)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1136_22706",
    x1: 21,
    y1: 3.5,
    x2: 3,
    y2: 21.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#659C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428B51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1136_22706",
    x1: 15,
    y1: 10.5,
    x2: 11.3077,
    y2: 16.0385,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#659C52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#428B51"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/Circle_Check.5aca69fca43d18d2c9dfe8e2a2b073a0.svg";
export { ForwardRef as ReactComponent };